// OpenAI API Key Configuration
// ERROR: DO NOT COMMIT THIS FILE TO GIT IF PUBLIC
export const OPENAI_API_KEY = "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";
